import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const ChevronUp = createIcon({
  displayName: "Chevron",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Chevron Up Icon </title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7.97998C12.1326 7.97998 12.2597 8.03266 12.3535 8.12643L19.3935 15.1664C19.5888 15.3617 19.5888 15.6783 19.3935 15.8735C19.1983 16.0688 18.8817 16.0688 18.6864 15.8735L12 9.18709L5.31351 15.8735C5.11825 16.0688 4.80167 16.0688 4.60641 15.8735C4.41115 15.6783 4.41115 15.3617 4.60641 15.1664L11.6464 8.12643C11.7402 8.03266 11.8674 7.97998 12 7.97998Z"
      />
    </>
  )
});
